/* eslint-disable jsx-a11y/label-has-associated-control */
import PropTypes from "prop-types";
import {useContext, useEffect,useState } from 'react'
import { UserContext } from "../../../contexts/user.context";
import { getPropertyList, getSingleProperty } from "../../../api/wordpress";
import { isArray } from "../../../utils/functions";
import PropertiesModal from "../../../components/modals/properties-modal.component";
import ScheduleModal from "../../../components/modals/schedule-modal.component";
import GenericModal from "../../../components/modals/generic-modal.component";
import { sendPaymentRequest, auth } from "../../../utils/firebase";
import { useNavigate } from "react-router-dom";
import ErrorModal from "../../../components/modals/error-modal.component";


const MessageForm = ({
  handleSubmit,
  text,
  setText,
  setImg,
  img,
  isSending,
  chat_email
}) => {
const { user } = useContext(UserContext);
 const [scheduleModalState, setScheduleModalState] = useState(false);
 const [property, setProperty] = useState([]);
 const [propertyLoader, setPropertyLoader] = useState(true);
const [showFab, setShowFab] = useState(false);
const [showProperties, setShowProperties] = useState(false);
const [propertyList, setPropertyList] = useState([]);
const [selectedProperty, setSelectedProperty] = useState(null);
const [paymentModal, setPaymentModal] = useState(false);
const [ispayment, setIspayment] = useState(false);
const [showaddbankerrormodal, setShowaddbankerrormodal] = useState(false);
const email = JSON.parse(localStorage.getItem("user"))?.user?.user_email;
const token = JSON.parse(localStorage.getItem("user"))?.token;
const [isLoading,  setIsLoading] = useState(false)
const navigate = useNavigate()
 
  useEffect(()=>{
          const  fetchProperties = async () => {
                  let arr = [];
       const response = await getPropertyList(token, { author: email });
             if (!isArray(response.data)) {
               if (Number.isInteger(Number(Object.keys(response.data)[0]))) {
                 arr = Object.keys(response.data).map((key) => {
                   return response.data[key];
                 });
               } else {
                 arr[0] = response.data;
               }
             } else {
               arr = response.data;
             }
             setPropertyList(arr.filter((item) => item.status === "publish"));
   
  }
  fetchProperties();
  }
  , []);


  
  const propertyListRequest = async () => {
    const response = await getSingleProperty(token, { slug: selectedProperty.slug });
    setPropertyLoader(false);
    console.log(response.data.author);
        setProperty(response.data);
        setScheduleModalState(true);
        setSelectedProperty(false)
    };

    
     useEffect(() => {
        if (selectedProperty) {
          if(paymentModal){
             setPaymentModal(true) 
          }else{
            setPaymentModal(false)
            setPropertyLoader(true);
            propertyListRequest();
          }
          }
      }, [selectedProperty]);


useEffect(() => {
  const handleClickOutside = (event) => {
    if (showFab) {
      const fab = document.querySelector(".fab");
      if (fab && !fab.contains(event.target)) {
        setShowFab(false);
      }
    }
  };

  document.addEventListener("click", handleClickOutside);
  return () => {
    document.removeEventListener("click", handleClickOutside);
  };
}, [showFab]);


const handleShowFab = () => {
  setShowFab(!showFab);
}
const handleCreatePaymentRequest =async()=>{
 setIsLoading(true)
  try{
 await sendPaymentRequest(
            chat_email,
            auth.currentUser.uid,
            selectedProperty?.acf.price,
            selectedProperty?.property_type,
            selectedProperty?.title,
            String(selectedProperty?.id)
        )      
        
    } catch (error) {
      console.warn(error)
        alert(error.message); 
    }finally{
      setIsLoading(false)
        setPaymentModal(false);
        setShowFab(false);
    }
}


 
    return (
      <div className="relative">
      <form
        className="relative bottom-0 flex items-center justify-between w-full p-3 border-t border-neutral-200"
        onSubmit={handleSubmit}
      >
        <button
          type="button"
          className="cursor-pointer disabled:cursor-not-allowed"
          disabled={isSending}
        >
          <label htmlFor="img" className="">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-5 h-5 text-gray-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
              />
            </svg>
            <input
              onChange={(e) => setImg(e.target.files[0])}
              type="file"
              id="img"
              accept="image/*"
              style={{ display: "none" }}
            />
          </label>
        </button>

        <div className="flex flex-col w-full mx-3">
          {img !== null && img !== "" && (
            <div className="relative flex flex-row mb-1">
              <button
                onClick={() => setImg("")}
                className="absolute bg-secondary flex items-center justify-center text-white rounded-full w-4 h-4 text-sm"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-3 h-3"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
              <img
                src={URL.createObjectURL(img)}
                className="w-[50px] h-[50px] border rounded-md"
                alt="attachement"
              />
            </div>
          )}

          <input
            type="text"
            placeholder="Message"
            value={text}
            className="block w-full py-2 pl-4 border border-gray-300 rounded-full outline-none font-light focus:text-gray-700"
            onChange={(e) => setText(e.target.value)}
          />
        </div>

        
        {
          user.viewing_as === "owner" &&

        <button
            onClick={handleShowFab}
            type="button"
            className="bg-primary fab text-white rounded-full aspect-square w-16 mr-4 flex justify-center items-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 4.5v15m7.5-7.5h-15"
              />
            </svg>
          </button>
        }
        <button
          disabled={isSending}
          className="bg-primary flex gap-2 py-2 px-4 text-white border rounded-lg items-center disabled:cursor-not-allowed"
          type="submit"
        >
          Send
          <svg
            className="w-5 h-5 text-white origin-center transform rotate-90"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z" />
          </svg>
        </button>
      </form>

      <PropertiesModal
        action={() => {
          setShowProperties(false);
          setPaymentModal(false);
        }}
        close={() => {
          setShowProperties(false);
          setPaymentModal(false);
        }}
        state={showProperties}
        properties={propertyList}
        handlePropertySelect={(data) => {
            if(ispayment){
              setPaymentModal(true);
            }
          setSelectedProperty(data);
          setShowProperties(false);
        }}
      
      />
        { !propertyLoader && 
          <ScheduleModal
            property={property}
            chat_email={chat_email}
            action={() => {
              setScheduleModalState(false);
            }}
            state={scheduleModalState}
          ></ScheduleModal>
          
        }

        {
          paymentModal &&
          <GenericModal
          onClick={(event) => {
        if (event.target.classList.contains("close-modal")) {
          setPaymentModal(false)
        }
      }}
      modalState={true}
          >
            <div className="bg-white w-full p-6 justify-center items-center text-center">
             <h3 className="">Are sure you want to create a payment request? </h3> 
             <div className="flex justify-center items-center gap-8 mt-4">
              <button className="border-primary border rounded-lg w-24 h-10 hover:bg-primary/50" disabled={isLoading} onClick={()=>setPaymentModal(false)} >Cancel</button>
              <button className='bg-primary text-white w-24 h-10 hover:bg-primary/80 rounded-lg' disabled={isLoading} onClick={handleCreatePaymentRequest}>
              {
                isLoading ? "Loading..." : "Yes"
              }
              
              </button>
             </div>
              </div>

          </GenericModal>

        }

      {showaddbankerrormodal && (
          <ErrorModal
            action={() => {
          setShowaddbankerrormodal(false);
        }}
        state={showaddbankerrormodal}
        title="An Error Occured!"
        description="Add bank account to create payment request"
          >

          <div className="flex justify-center items-center gap-8 mt-4">
              <button className="border-primary border rounded-lg w-24 h-10 hover:bg-primary/50" onClick={()=>setShowaddbankerrormodal(false)} >Cancel</button>
              <button className='bg-primary text-white w-24 h-10 hover:bg-primary/80 rounded-lg' onClick={()=>{
                navigate('/dashboard/my-account')
                setShowaddbankerrormodal(false)
              }}>Add</button>
           </div>

          </ErrorModal>
      )}
        

   <div className="relative fab ">
   
      {showFab && (
        <div className="absolute bottom-16 right-20 flex flex-col gap-2  bg-white p-3 rounded-lg shadow-lg">
          <button
            onClick={() => setShowProperties(true)}
            className="hover:bg-primary/10  rounded-lg p-3 flex items-center justify-center border-b"   
          
          >
            Schedule
          </button>
          <button
            onClick={() => {
              if(user?.address){
                setShowProperties(true)
                setIspayment(true)
              }else{
                setShowaddbankerrormodal(true)
              }
            }}
            className="hover:bg-primary/10  rounded-lg p-3 flex items-center justify-center border-b"   

          >
            Create Payment Request
            </button>
   
        </div>
      )}
   </div>
    </div>
  );
};

MessageForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  setText: PropTypes.func.isRequired,
  setImg: PropTypes.func.isRequired,
  img: PropTypes.object,
  isSending: PropTypes.bool.isRequired,
};

export default MessageForm;
